// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5a61053e] .no-empty .el-table__empty-block {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
